import { Pipe, PipeTransform } from '@angular/core';
import { ContextMenuComponent } from '../../services/context-menu.service';

@Pipe({
  name: 'inferredContextOpen',
  standalone: true,
})
export class InferredContextOpenPipe implements PipeTransform {
  transform(menus: ContextMenuComponent[], name: string): boolean {
    if (!menus) return false;
    return menus.some(menu => menu.contextHoverIdentifiers?.includes(name));
  }
}
